import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { ApiVisa } from '../../shared/api-visa.model';
import { SupplierImportFileContainerModel } from '../../../../../../models/aggregates/erp/entity/supplier-file-import-container.model';
@Injectable({ providedIn: 'root' })
export class SupplierImportFileService extends BaseApiTemplateService<SupplierImportFileContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/supplier/import-file-hdr';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/supplier/import-file-hdr';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/supplier/import-file-hdr';
    this.httpClient = http;
  }

  public uploadImportFile(formData: FormData, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/backoffice-ep'
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }
}
